import { BRAND } from "@/constants/brand";
import { isTestMode } from "@/services/configService";

const badgeBaseClassName =
  "flex h-9 w-40 shrink-0 items-center rounded-cn-lg px-2.5 text-sm font-medium text-white shadow-lg";

export function Footer() {
  const showTestBadge = isTestMode();

  return (
    <footer className="shell-footer flex-shrink-0 mt-auto">
      <div
        className={`mx-auto max-w-7xl px-4 ipad:px-6 py-3 ipad:py-4 text-xs ipad:text-sm flex flex-col ipad:grid ipad:items-center gap-2 ipad:gap-3 ${
          showTestBadge ? "ipad:grid-cols-3" : "ipad:grid-cols-2"
        }`}
      >
        <div className="min-w-0 max-w-[17rem] mx-auto ipad:mx-0 ipad:max-w-none text-cn-text text-center ipad:text-left leading-snug">
          <p>
            {BRAND.copyrightPrefix} {BRAND.eiasFullTitle}.
            <br />
            {BRAND.moduleTitle}
          </p>
        </div>

        {showTestBadge && (
          <div className="flex flex-row flex-wrap items-center justify-center gap-2 mx-auto ipad:justify-self-center">
            <div className={`${badgeBaseClassName} bg-amber-600 justify-center`}>
              <span className="whitespace-nowrap">Тестовый режим</span>
            </div>
          </div>
        )}

        <div className="flex flex-col gap-1 text-center ipad:text-right min-w-0 ipad:justify-self-end">
          <div>
            Техподдержка:{" "}
            <a
              href={`mailto:${BRAND.supportEmail}`}
              className="text-cn-primary hover:text-cn-primary-dark underline underline-offset-2"
            >
              {BRAND.supportEmail}
            </a>
          </div>
          <div>
            <a
              href={`tel:${BRAND.supportPhone.replace(/\s/g, "")}`}
              className="text-cn-primary hover:text-cn-primary-dark underline underline-offset-2"
            >
              {BRAND.supportPhone}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
